// component with a header (title left, nav right) and a footer and a main content section between
// pass children through to main content section
import React from 'react';
// import NavLink from 'react-router-dom';
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import './BasicLayout.css';

function BasicLayout({ children }) {
    return (
        <>
            <Header />
            <main className="basic-layout-main">{children}</main>
            <Footer />
        </>
    );
}

export default BasicLayout;
